export default "__VITE_ASSET__BDdRqOmt__"